// Map module exports to Autodesk.* namespaces for backwards API compatibility.
// Input is the module returned by require("index.js")
export function initializeGlobalNamespaces(LMV) {
  var av = Autodesk.Viewing;
  var avp = av.Private;
  var avm = av.Math;
  var avs = av.Scene;
  var avu = av.UI;
  var ave = av.Extensions;

  // For symbols that are literals (not objects), we assign a getter to make sure we see updates of the original value.
  let exportSymbol = function (obj, sourceObj, prop) {
    if (!(LMV[prop] instanceof Object)) {
      Object.defineProperty(obj, prop, {
        get() {
          return sourceObj[prop];
        },
        set(newValue) {
          sourceObj[prop] = newValue;
        },
        enumerable: true,
        configurable: true
      });
    } else {
      obj[prop] = sourceObj[prop];
    }
  };
  //Move exports from module into viewer namespaces
  for (let m in LMV.av) {
    exportSymbol(av, LMV.av, m);
  }

  for (let m in LMV.avp) {
    exportSymbol(avp, LMV.avp, m);
  }

  for (let m in LMV.avm) {
    exportSymbol(avm, LMV.avm, m);
  }

  for (let m in LMV.avs) {
    exportSymbol(avs, LMV.avs, m);
  }

  for (let m in LMV.avu) {
    exportSymbol(avu, LMV.avu, m);
  }

  for (let m in LMV.ave) {
    exportSymbol(ave, LMV.ave, m);
  }

  //Put those in the global module for compatibility with existing code
  //that does not consistently require("three").
  av.getGlobal().THREE = LMV.THREE;
  av.getGlobal().LMV = LMV;
}